import React from 'react';
import styled from 'styled-components';
import __ from '../utils/translator';

export default styled.span.attrs({
  title: __('Outlet Only'),
})`
  display: inline-block;
  width: .5rem;
  height: .5rem;
  background-color: #000000;
  border-radius: 50%;
  margin-right: .25rem;
`;
